import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';
import { CoreAppComponent } from '../../../core/core-app.component.js';
import { LayoutSize, LayoutStyles } from 'lib/ui/layout/layout-ui.service.js';

@Component({
    selector: 'layout-clean-page',
    templateUrl: './layout-clean-page.component.html',
    styleUrls: ['./layout-clean-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LayoutCleanPageComponent extends CoreAppComponent {
	public readonly layoutSize = input<LayoutSize>();

	public readonly layoutSizeStyles: Signal<LayoutStyles> = computed(() => {
		return this.dependencies.layoutUiService.getLayoutSizeStyles({
			screenService: this.dependencies.screenService,
			type: this.layoutSize() ?? 'large'
		});
	});
}
